/**
 * Thin wrapper around the Median.co OneSignal JS bridge.
 * All calls are no-ops when running outside the Median app (e.g. desktop browser).
 *
 * Call login() after the user authenticates so OneSignal associates this device
 * with the user's external_id. Call logout() before clearing the auth token.
 */
export default class OneSignalUtils {
  static login(username: string | undefined): void {
    if (!username) return;
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).median?.onesignal?.login(username);
    } catch {
      // Silently ignore — bridge unavailable outside Median app
    }
  }

  static logout(): void {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).median?.onesignal?.logout();
    } catch {
      // Silently ignore
    }
  }
}
